import { NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, NgModule } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { IFormBuilder, IFormGroup } from '@rxweb/types';
import { InputModule } from '@shared/controls/input/input.component';
import { DataService } from '@shared/services/data.service';
import { ToastModule } from '@shared/toast/toast.component';
import { ToastService } from '@shared/toast/toast.service';
import { RegExPatterns } from '@shared/utils/reg-ex-patterns';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, ReactiveFormsModule],
})
export class NewsletterComponent {
  public form: IFormGroup<{ email: string }>;

  public submitPending: boolean = false;

  public errorMessage: string = null;

  public showMessage: boolean = false;

  constructor(
    @Inject(UntypedFormBuilder) private fb: IFormBuilder,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private dataService: DataService<{ email: string }>
  ) {
    this.form = this.fb.group<{ email: string }>({
      email: [null, [Validators.required, Validators.pattern(RegExPatterns.EMAIL_VALIDATION)]],
    });
  }

  public onSubmit(): void {
    this.showMessage = false;
    this.errorMessage = null;
    if (this.form.valid && !this.submitPending) {
      this.submitPending = true;
      const { email } = this.form.getRawValue();
      this.dataService
        .postData(
          {
            root: 'newsletter',
            category: 'subscribers',
          },
          {
            email,
          }
        )
        .pipe(
          finalize(() => {
            this.submitPending = false;
            this.cdr.markForCheck();
          })
        )
        .subscribe(
          () => {
            // TODO replace message
            this.toastService.success('Success');
            this.showMessage = true;
            this.errorMessage = null;
            this.form.reset();
          },
          ({ error }: HttpErrorResponse) => {
            this.showMessage = true;
            this.errorMessage = error['hydra:description'];
            this.toastService.error(this.errorMessage);
          }
        );
    } else {
      this.form.markAllAsTouched();
    }
  }
}

@NgModule({
  imports: [ReactiveFormsModule, ToastModule, InputModule, NewsletterComponent],
  exports: [NewsletterComponent],
})
export class NewsletterModule {}
